import { lazy } from 'react';

// project imports
import GuestGuard from 'utils/route-guard/GuestGuard';
import MinimalLayout from 'layout/MinimalLayout';
import NavMotion from 'layout/NavMotion';
import Loadable from 'ui-component/Loadable';
import RouterErrorElement from './RouterErrorElement';

// login routing
const AuthLoading = Loadable(lazy(() => import('views/pages/authentication/Loading')));
const PrivacyPolicy = Loadable(lazy(() => import('views/policy')));
const TermsOfService = Loadable(lazy(() => import('views/terms')));
// ==============================|| AUTH ROUTING ||============================== //

const LoadingRoutes = {
    path: '/',
    element: (
        <NavMotion>
            <GuestGuard>
                <MinimalLayout />
            </GuestGuard>
        </NavMotion>
    ),
    errorElement: <RouterErrorElement />,
    children: [
        {
            path: '/paystatus',
            element: <AuthLoading />
        },
        {
            path: '/privacy',
            element: <PrivacyPolicy />
        },
        {
            path: '/terms',
            element: <TermsOfService />
        }
    ]
};

export default LoadingRoutes;
